import { useState, useContext } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Eye, EyeOff, LogIn, Loader2 } from "lucide-react";

// styles
import styles from "./styles.module.css";
// context
import { Context } from "../../../context/UserContext";

function Login() {
    const { login } = useContext(Context);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [user, setUser] = useState({ email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    // plano vindo da URL (ex: /login?plan=plus), repassado após login
    const planFromUrl = searchParams.get('plan');

    function handleChange(e) {
        setUser(prev => ({ ...prev, [e.target.name]: e.target.value }));
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        await login(user);
        setLoading(false);

        // Se veio de um link de plano pago (ex: /login?plan=plus), manda
        // pra tela de Planos pra continuar o checkout com o Card Brick.
        // Senão, vai direto pro dashboard normalmente.
        if (planFromUrl && planFromUrl !== 'free') {
            navigate(`/plans?plan=${planFromUrl}`);
        } else {
            navigate('/dashboard');
        }
    }

    return (
        <div className={styles.page}>
            <div className={styles.card}>

                {/* Voltar */}
                <Link to="/" className={styles.back}>
                    <ArrowLeft size={15} /> Voltar ao início
                </Link>

                {/* Header */}
                <div className={styles.header}>
                    <div className={styles.iconWrap}>
                        <LogIn size={24} />
                    </div>
                    <h1 className={styles.title}>Entrar</h1>
                    <p className={styles.sub}>Acesse sua conta do NotaFácil</p>
                </div>

                {/* Banner quando vem de plano */}
                {planFromUrl && planFromUrl !== 'free' && (
                    <div className={styles.planBanner}>
                        🔐 Faça login para continuar e assinar o plano <strong>{planFromUrl.charAt(0).toUpperCase() + planFromUrl.slice(1)}</strong>.
                    </div>
                )}

                <form onSubmit={handleSubmit} className={styles.form}>

                    <div className={styles.field}>
                        <label>E-mail *</label>
                        <input
                            name="email"
                            type="email"
                            placeholder="seu@email.com"
                            value={user.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className={styles.field}>
                        <label>Senha *</label>
                        <div className={styles.passWrap}>
                            <input
                                name="password"
                                type={showPassword ? "text" : "password"}
                                placeholder="Digite sua senha"
                                value={user.password}
                                onChange={handleChange}
                                required
                            />
                            <button
                                type="button"
                                className={styles.eyeBtn}
                                onClick={() => setShowPassword(v => !v)}
                            >
                                {showPassword ? <Eye size={16} /> : <EyeOff size={16} />}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className={styles.btn} disabled={loading}>
                        {loading
                            ? <Loader2 size={18} className={styles.spinner} />
                            : 'Entrar'
                        }
                    </button>
                </form>

                <p className={styles.registerLink}>
                    Não tem conta? <Link to="/register">Cadastre-se grátis</Link>
                </p>

            </div>
        </div>
    );
}

export default Login;
